import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoadingOverlay from 'react-loading-overlay';
import { withRouter, Link } from 'react-router-dom';
import CKEditor from 'ckeditor4-react';

import { verifyToken, cleanRedirectState } from '../../../../state/services/authService';
import { getEmailTemplateDetails, updateEmailTemplateDetails } from '../../../../state/services/emailTemplateService';

class EditEmailTemplates extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            loading: false,
            isShowFPDataSlider: false,
            emailName: '',
            sectionName: '',
            emailBody: '',
            emailTemplateDetails: { id: 0, emailName: '', sectionName: '', emailBody: '' },
            pageItemCnt: 10,
            pageInd: 0,
            pageCnt: 0,
        };

    }

    static propTypes = {
        verifyToken: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        redirect: PropTypes.bool.isRequired,
        getEmailTemplateDetails: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        cleanRedirectState: PropTypes.func.isRequired,
        updateEmailTemplateDetails: PropTypes.func.isRequired,
        deleteFpCarrier: PropTypes.func.isRequired,
        deleteFpZone: PropTypes.func.isRequired,
        urlAdminHome: PropTypes.string.isRequired,
    }

    componentDidMount() {
        const id = this.props.match.params.id;

        const token = localStorage.getItem('token');

        if (token && token.length > 0) {
            this.props.verifyToken();
        } else {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/admin');
        }

        this.props.getEmailTemplateDetails(id);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { redirect, emailTemplateDetails, id, pageInd, pageCnt } = newProps;
        const currentRoute = this.props.location.pathname;
        if (redirect && currentRoute != '/') {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/admin');
        }

        const { emailName, sectionName, emailBody } = emailTemplateDetails;

        if (emailTemplateDetails) {
            this.setState({ emailTemplateDetails });
            this.setState({ emailName: emailName });
            this.setState({ sectionName: sectionName });
            this.setState({ emailBody: emailBody });
        }

        if (id) {
            this.setState({ id });
        }

        if (pageCnt) {
            this.setState({ pageCnt: parseInt(pageCnt), pageInd: parseInt(pageInd) });
        }
    }

    onSubmit(event) {
        this.setState({ loading: true });
        const { emailTemplateDetails, emailName, sectionName, emailBody } = this.state;
        let data = { id: emailTemplateDetails.id, emailName: emailName, sectionName: sectionName, emailBody: emailBody };
        this.props.updateEmailTemplateDetails(data);
        this.setState({ loading: false });
        this.props.history.push('/admin/emails');
        event.preventDefault();
    }

    onClickDelete(typeNum, row) {
        if (typeNum === 0) { // Duplicate line
            this.props.deleteFpCarrier({ id: row.id });
        } else if (typeNum === 1) { // Duplicate line detail
            this.props.deleteFpZone({ id: row.id });
        }
    }

    render() {
        const { emailTemplateDetails } = this.state;

        return (
            <div>

                <div className="pageheader">
                    <h1>Edit Email Template</h1>
                    <div className="breadcrumb-wrapper hidden-xs">
                        <span className="label">You are here:</span>
                        <ol className="breadcrumb">
                            <li><a href={this.props.urlAdminHome}>Home</a>
                            </li>
                            <li><Link to="/admin/emails">Email Templates</Link></li>
                            <li className="active">Edit</li>
                        </ol>
                    </div>
                </div>
                <section id="main-content" className="animated fadeInUp">
                    <LoadingOverlay
                        active={this.state.loading}
                        spinner
                        text='Loading...'
                    />

                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h3 className="panel-title">Edit Email Template <b>{emailTemplateDetails.emailName}</b></h3>
                                    <div className="actions pull-right">
                                        <a onClick={(e) => this.onClickOpenSlide(e)} className="open-slide"><i className="fa fa-columns" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                                <div className="panel-body">
                                    <form onSubmit={(e) => this.onSubmit(e)} role="form">
                                        <input name="id" type="hidden" value={this.state.id} />
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Template Name</label>
                                            <input readOnly name="emailName" type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter Email Name" value={this.state.emailName} onChange={(e) => this.setState({ emailName: e.target.value })} />
                                            <i>*This field cannot be changed</i>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Section Name</label>
                                            <input readOnly name="sectionName" type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter Section Name" value={this.state.sectionName} onChange={(e) => this.setState({ sectionName: e.target.value })} />
                                            <i>*This field cannot be changed</i>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Email Body</label>
                                            <br /><i>*Please do no modify or remove variables with curly braces {}</i>
                                            <CKEditor
                                                data={this.state.emailBody}
                                                onInit={editor => {
                                                    console.log('Editor is ready to use!', editor);
                                                }}
                                                onChange={(event) => {
                                                    const data = event.editor.getData();
                                                    this.setState({ emailBody: data });
                                                }}
                                                onBlur={(event, editor) => {
                                                    console.log('Blur.', editor);
                                                }}
                                                onFocus={(event, editor) => {
                                                    console.log('Focus.', editor);
                                                }}
                                            />
                                        </div>

                                        <button type="submit" className="btn btn-primary pull-right">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redirect: state.auth.redirect,
        emailTemplateDetails: state.emailTemplate.emailTemplateDetails,
        username: state.auth.username,
        pageCnt: state.fp.pageCnt,
        pageItemCnt: state.fp.pageItemCnt,
        pageInd: state.fp.pageInd,
        urlAdminHome: state.url.urlAdminHome,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        verifyToken: () => dispatch(verifyToken()),
        cleanRedirectState: () => dispatch(cleanRedirectState()),
        getEmailTemplateDetails: (fp_id) => dispatch(getEmailTemplateDetails(fp_id)),
        updateEmailTemplateDetails: (emailTemplateDetails) => dispatch(updateEmailTemplateDetails(emailTemplateDetails)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditEmailTemplates));



// WEBPACK FOOTER //
// ./src/pages/admin/AdminViews/EmailTemplates/EditEmailTemplates.js